var _ellipse, _circle, _ellipse2, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooddelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#22FFAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9972,
    cy: 48.8333,
    r: 35.7165,
    fill: "#00E98F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_28976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 104
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.2793,
    cy: 51.9999,
    rx: 52,
    ry: 52,
    fill: "#314DD8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_28976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6863 41.8243H14.7696C12.6507 41.8243 10.9492 43.5418 10.9492 45.6446C10.9492 45.741 10.9492 100.976 10.9492 101.072C10.9492 103.175 12.6507 104.876 14.7696 104.876H18.7023V41.8243H18.6863Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6934 41.8243H17.8194C15.7005 41.8243 13.999 43.5418 13.999 45.6446C13.999 45.741 13.999 100.976 13.999 101.072C13.999 103.175 15.7005 104.892 17.8194 104.892H40.6934C42.7962 104.892 44.5138 103.191 44.5138 101.072C44.5138 100.976 44.5138 66.2072 44.5138 66.2072C44.5138 66.2072 44.5138 45.741 44.5138 45.6607C44.5138 43.5418 42.7962 41.8243 40.6934 41.8243Z",
    fill: "#0C1A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.732 49.144H15.7808V98.6862H42.732V49.144Z",
    fill: "#85FFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2484 103.608C30.516 103.608 31.5437 102.58 31.5437 101.313C31.5437 100.045 30.516 99.0174 29.2484 99.0174C27.9808 99.0174 26.9531 100.045 26.9531 101.313C26.9531 102.58 27.9808 103.608 29.2484 103.608Z",
    fill: "#635245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.215 18.5949L68.0885 17.4175L62.5635 26.7977L58.4176 58.3216C58.2318 59.7373 59.285 61.0184 60.7712 61.1541C60.8218 61.1584 60.8724 61.1627 60.923 61.1669L75.9907 62.6234C77.4807 62.7747 78.8473 61.7338 79.0293 60.3025L83.1752 28.7786L80.215 18.5949Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9171 17.3543L81.3429 18.7515L81.7061 16.0211L67.2803 14.624L66.9171 17.3543Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7391 45.5384L59.0726 45.6705L59.467 23.9172L63.2868 19.8154L67.1172 23.8916L66.7391 45.5384Z",
    fill: "#E4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7569 19.9977L47.9572 24.1099L47.5629 45.8632L59.0726 45.6703L59.467 23.917L63.2868 19.8151L51.7569 19.9977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2217 19.8198L51.757 19.9979L51.8164 16.3179L63.2762 16.1245L63.2217 19.8198Z",
    fill: "#D7DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2867 19.8152L51.7568 19.9978L47.9571 24.11L59.4669 23.9171L63.2867 19.8152Z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6707 30.6239C53.6966 30.0607 54.0092 29.5501 54.4945 29.2352L54.6112 25.8519L40.0636 25.2096C39.7021 25.6365 39.1249 25.9018 38.4654 25.8648C37.8252 25.8301 37.2569 25.5108 36.9374 25.064L34.7234 24.965L34.4427 32.8193C34.9622 33.0549 35.3157 33.5446 35.292 34.0885C35.2684 34.6324 34.8831 35.0955 34.3534 35.2882L34.3046 36.7272L54.1924 37.6141L54.4015 32.0746C53.9146 31.7257 53.6426 31.2063 53.6707 30.6239Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.665 30.682C53.6909 30.1188 54.0035 29.6082 54.4889 29.2932L54.6122 25.8519L44.7062 25.4128L44.2681 37.1736L54.1741 37.6127L54.3765 32.1306C53.9282 31.7861 53.6369 31.2644 53.665 30.682Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1996 30.8091C41.1255 30.9158 41.9626 30.2518 42.0693 29.3259C42.176 28.4 41.512 27.5629 40.5861 27.4562C39.6602 27.3495 38.8231 28.0135 38.7164 28.9394C38.6097 29.8653 39.2738 30.7024 40.1996 30.8091Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8841 35.0097H70.5801V93.792H87.8841V35.0097Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5804 35.0097H27.3364V93.792H70.5804V35.0097Z",
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8844 35.0097H79.2324V93.792H87.8844V35.0097Z",
    fill: "#252130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2321 86.2635L70.5801 93.7919H87.868V93.5351L79.2321 86.2635Z",
    fill: "#252130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5561 85.967H30.3399V69.1606H15.54",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9172 85.1485C58.784 85.1485 59.4903 84.3138 59.4903 83.2864C59.4903 82.2591 58.784 81.4726 57.9172 81.4726C57.9172 81.4726 49.522 81.4726 49.7307 81.4726C49.8591 81.4726 58.174 81.4726 58.174 81.4726H61.1597C62.0265 81.4726 62.7328 80.6379 62.7328 79.6105C62.7328 78.5832 62.0265 77.7485 61.1597 77.7485C61.1597 77.7485 49.4738 77.7325 49.6986 77.7325C49.827 77.7325 50.0196 77.7325 50.0196 77.7325H51.063H58.1419H62.7006C63.5675 77.7325 64.2737 76.8978 64.2737 75.8704C64.2737 74.8431 63.5675 74.0084 62.7006 74.0084C62.7006 74.0084 49.4257 73.9763 49.6344 73.9763C49.7628 73.9763 49.9554 73.9763 49.9554 73.9763H50.9988H58.0777H61.0312C61.8981 73.9763 62.6043 73.1416 62.6043 72.1143C62.6043 71.087 61.8981 70.2523 61.0312 70.2523H58.0456H42.7641L49.1528 63.8796C49.7628 63.1573 49.7628 61.9694 49.1528 61.2471C48.5428 60.5248 47.4192 60.7013 46.9216 61.2471L43.9038 63.3981L34.2245 70.2202C34.2245 70.2202 32.6674 71.5685 32.0896 73.0132H30.271L30.3031 83.5593H32.2982C32.5711 84.1372 32.9724 84.5706 33.5182 84.7632C34.9629 85.2287 57.9172 85.1485 57.9172 85.1485Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1113 9.27386C29.7837 11.6616 24.2925 15.2976 19.812 19.7964M15.9287 24.2343C14.6953 25.8419 13.5721 27.5264 12.5649 29.2749C11.816 30.5747 11.1313 31.91 10.5131 33.2753",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2838 51.5769C98.5516 60.1206 96.433 68.6469 92.1044 76.1089",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooddelivery);
export default __webpack_public_path__ + "static/media/food delivery.c998983a58cc11e9abf6736249f5d194.svg";
export { ForwardRef as ReactComponent };